import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { connect } from "react-redux";
import { S3_GEOJSON_FOLDER_URL } from "Config";

const minutesToHms = (d) => {
  d = Number(d);
  const h = Math.floor(d / 60);
  const m = Math.floor(d % 60);
  const hDisplay = h > 0 ? h + " h " : "00 h ";
  const mDisplay = m > 0 ? m + " min " : "00 min ";
  return hDisplay + mDisplay;
};

const BelgiumCityMapWebinar = ({ cityPercentageData, firstVariant = 5000, secondVariant = 2000, thirdVariant = 500 }) => {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const geoJsonCacheRef = useRef(null);
  const geoJsonPromiseRef = useRef(null);

  const getColorBasedOnPercentage = (value) => {
    return value > firstVariant
      ? "#2d74d0"
      : value > secondVariant
        ? "#4582e4"
        : value > thirdVariant
          ? "#88b0ed"
          : "#dddddd";
  };

  const getCityStyle = (feature) => {
    const cityName = feature.properties.name;
    const duration = cityPercentageData && cityPercentageData[cityName] ? cityPercentageData[cityName][0] : 0;

    return {
      color: "#757575",
      weight: 0.8,
      opacity: 1,
      fillColor: getColorBasedOnPercentage(duration),
      fillOpacity: 1,
    };
  };

  const addCityTooltip = (feature, layer) => {
    const cityName = feature.properties.name;
    const duration = cityPercentageData && cityPercentageData[cityName] ? cityPercentageData[cityName][0] : 0;
    layer.bindTooltip(cityName + ": " + minutesToHms(duration));
  };

  const addGeoLayer = (geoData) => {
    L.geoJSON(geoData, {
      style: (feature) => getCityStyle(feature),
      onEachFeature: (feature, layer) => addCityTooltip(feature, layer),
    }).addTo(mapRef.current);
  };

  // componentDidMount
  useEffect(() => {
    mapRef.current = L.map(mapContainerRef.current).setView([50.5, 4.5], 7);

    if (geoJsonCacheRef.current) {
      addGeoLayer(geoJsonCacheRef.current);
      return;
    }

    if (!geoJsonPromiseRef.current) {
      geoJsonPromiseRef.current = fetch(
        S3_GEOJSON_FOLDER_URL + "/billing/geojson/belgium.geojson"
      ).then((res) => res.json());
    }

    geoJsonPromiseRef.current.then((data) => {
      geoJsonCacheRef.current = data;
      addGeoLayer(data);
    });

    // componentWillUnmount
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  // componentDidUpdate — quand les données changent
  useEffect(() => {
    if (!mapRef.current) return;

    // Clear existing GeoJSON layers
    mapRef.current.eachLayer((layer) => {
      if (layer instanceof L.GeoJSON) {
        mapRef.current.removeLayer(layer);
      }
    });

    // Re-add with updated data
    if (geoJsonCacheRef.current) {
      addGeoLayer(geoJsonCacheRef.current);
    }
  }, [cityPercentageData, firstVariant, secondVariant, thirdVariant]);

  return (
    <div
      ref={mapContainerRef}
      style={{ width: "100%", height: "300px", zIndex: 1 }}
    />
  );
};

const mapStateToProps = (state) => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BelgiumCityMapWebinar);


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/BelgiumMapWebinar.js